var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunergyTechLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 180,
    viewBox: "0 0 420 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Sunergy Tech logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Sun icon over a solar panel with Sunergy Tech wordmark.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sunFill",
    x1: 52,
    y1: 24,
    x2: 110,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD58A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA44D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "panelFill",
    x1: 26,
    y1: 70,
    x2: 126,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3557D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shieldFill",
    x1: 18,
    y1: 96,
    x2: 129,
    y2: 164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F86FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2948C5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glowBlue",
    x: 0,
    y: 0,
    width: 420,
    height: 180,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 4,
    floodColor: "#1D39B8",
    floodOpacity: 0.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glowBlue)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 67,
    r: 31,
    fill: "url(#sunFill)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FF9D70",
    strokeWidth: 8,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 6V28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 11L60 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 23L45 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 43L38 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 67H36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 91L38 84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 111L45 94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 123L60 102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 128V106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 123L92 102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 111L107 94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 91L114 84"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30 79H123L111 123H40L30 79Z",
    fill: "url(#panelFill)",
    stroke: "#2E49B7",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#9EB8FF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 91H118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 102H115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 113H112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 81L42 122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 81L64 123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 81L86 123"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 112C36 98 62 100 76 112C90 123 110 123 129 108V132C129 145 121 156 109 161L84 171C79 173 73 173 68 171L42 161C30 156 22 145 22 132L18 112Z",
    fill: "url(#shieldFill)",
    stroke: "#2D47A6",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 135C48 118 65 122 79 133C94 144 108 144 122 132",
    stroke: "#6FA2FF",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("text", {
    x: 165,
    y: 92,
    fontFamily: "Verdana, Geneva, sans-serif",
    fontSize: 52,
    fontWeight: 800,
    fill: "#1E46C6",
    stroke: "#16359C",
    strokeWidth: 10,
    paintOrder: "stroke"
  }, "Sunergy"), /*#__PURE__*/React.createElement("text", {
    x: 165,
    y: 145,
    fontFamily: "Verdana, Geneva, sans-serif",
    fontSize: 50,
    fontWeight: 800,
    fill: "#FFA44D",
    stroke: "#1E46C6",
    strokeWidth: 9,
    paintOrder: "stroke"
  }, "Tech"), /*#__PURE__*/React.createElement("text", {
    x: 165,
    y: 92,
    fontFamily: "Verdana, Geneva, sans-serif",
    fontSize: 52,
    fontWeight: 800,
    fill: "#2F61FF"
  }, "Sunergy"), /*#__PURE__*/React.createElement("text", {
    x: 165,
    y: 145,
    fontFamily: "Verdana, Geneva, sans-serif",
    fontSize: 50,
    fontWeight: 800,
    fill: "#FFB150"
  }, "Tech")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunergyTechLogo);
export default __webpack_public_path__ + "static/media/sunergy-tech-logo.01e16aa5cc49a84085a21ad482197ba2.svg";
export { ForwardRef as ReactComponent };